import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FaArrowLeft, FaTimesCircle } from "react-icons/fa";
import { getPaymentStatus } from "../services/paymentService";
import { clearMonobankPaymentDraft } from "../utils/monobankPaymentDraft";
import styles from "./PaymentStatus.module.css";

const statusLabels = {
  failed: "Оплата неуспішна",
  expired: "Час на оплату минув",
  canceled: "Оплату скасовано",
  reversed: "Платіж повернено",
};

const PaymentFailed = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId =
    searchParams.get("orderId") || sessionStorage.getItem("monobankPendingOrderId");

  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (orderId) {
      sessionStorage.setItem("monobankPendingOrderId", orderId);
    }
    clearMonobankPaymentDraft({ includePendingOrder: false });

    const loadStatus = async () => {
      if (!orderId) return;

      try {
        const data = await getPaymentStatus(orderId);
        if (data.paymentStatus === "paid") {
          navigate(`/payment/success?orderId=${orderId}`, { replace: true });
          return;
        }
        if (data.orderNumber) {
          sessionStorage.setItem(
            "monobankPendingOrderNumber",
            String(data.orderNumber)
          );
        }
        setStatus(data);
      } catch (error) {
        console.error("❌ Не вдалося отримати статус платежу:", error);
      }
    };

    loadStatus();
  }, [navigate, orderId]);

  const title =
    statusLabels[status?.paymentStatus] || "Оплату не вдалося підтвердити";

  return (
    <div className={styles.statusPage}>
      <div className={styles.statusPanel}>
        <FaTimesCircle className={`${styles.icon} ${styles.failedIcon}`} />
        <h1 className={styles.title}>{title}</h1>
        {status?.orderNumber && (
          <p className={styles.meta}>Замовлення №{status.orderNumber}</p>
        )}
        <p className={styles.text}>
          Замовлення не буде підтверджено як оплачене. Ви можете повернутися до
          кошика та обрати інший спосіб оплати або спробувати ще раз.
        </p>
        {(status?.paymentCancelReason ||
          status?.cancelReason ||
          status?.paymentError) && (
          <p className={styles.text}>
            {status.paymentCancelReason ||
              status.cancelReason ||
              status.paymentError}
          </p>
        )}
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.button}
            onClick={() => navigate("/cart")}
          >
            <FaArrowLeft /> Повернутися до кошика
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
